module.exports = __webpack_public_path__ + "static/logo-f6763dda0b0b907e238b69e871d960f3.svg";